import { useCallback, useMemo, useState, useEffect } from 'react';
import { useTheme } from '@emotion/react';

const useBreakpointIndex = function () {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const theme = useTheme();
  const {
    defaultIndex
  } = options;
  const breakpoints = theme && theme.breakpoints;
  const getIndex = useCallback(() => breakpoints.filter(bp => typeof window?.matchMedia === "function" && window.matchMedia(`screen and (min-width: ${bp})`).matches).length, [breakpoints]);
  const index = useMemo(() => {
    let retIndex = 0;
    if (defaultIndex) {
      if (typeof defaultIndex !== "number") {
        throw new TypeError(`Default breakpoint index should be a number. Got: ${defaultIndex}, ${typeof defaultIndex}`);
      } else if (defaultIndex < 0 || defaultIndex > breakpoints.length - 1) {
        throw new RangeError(`Default breakpoint index out of range. Theme has ${breakpoints.length} breakpoints, got index ${defaultIndex}`);
      }
      retIndex = defaultIndex;
    } else if (typeof window !== "undefined") {
      retIndex = getIndex();
    }
    return retIndex;
  }, [breakpoints.length, defaultIndex, getIndex]);
  const [value, setValue] = useState(index);
  useEffect(() => {
    const onResize = () => {
      const newValue = getIndex();
      if (value !== newValue) {
        setValue(newValue);
      }
    };
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [breakpoints, value, getIndex]);
  return value;
};

export { useBreakpointIndex as default };
